import { push } from 'connected-react-router';
import { put, select, call } from 'redux-saga/effects';
import { routes } from 'Routes/routesConfig';
import applicationSpinnerActions from 'redux/actions/applicationSpinnerActions';
import { getSynergySessionToken } from 'utils/sagas-utils';
import createServiceApi from 'api/mobilityContinuation/createService';
import mobilityContinuationActions from 'redux/actions/mobilityContinuationActions';
import {
  partnerSelector,
  selectMoveVersion,
  selectTenantId,
} from 'redux/selectors/config';
import { mobilityContinuationSelector } from 'redux/selectors/mobilityContinuation';
import type { MobilityContinuationState } from 'ts/types/mobility-continuation.types';
import { caseGuidCreatedSelector } from 'redux/selectors/caseCreation';

const { startLoad, stopLoad } = applicationSpinnerActions;

const getBody = (caseGuid: string, state: MobilityContinuationState) => {
  const body = {
    case_guid: caseGuid,
    pickup_location: state.start.temporalSelected,
    destination: state.destination.temporalSelected,
    questions_and_answers: state.coverageQuestions.answers,
    servicesList: [state.coverageQuestions.coverage[0].service],
  };
  return body;
};

export function* createService() {
  try {
    yield put(startLoad({}));
    const caseGuid: string = yield select(caseGuidCreatedSelector);
    const tenantId: string = yield select(selectTenantId);
    const moveVersion: string = yield select(selectMoveVersion);
    const partner: string = yield select(partnerSelector);
    const token: string = yield getSynergySessionToken();

    const mobilityContinuation: MobilityContinuationState = yield select(
      mobilityContinuationSelector,
    );
    const body = getBody(caseGuid, mobilityContinuation);

    const params = { tenantId, moveVersion, partner, token };

    const { result, status } = yield call(createServiceApi, {
      body,
      ...params,
    });

    const isSuccess = (statusCode: any) => [200, 201, 202].includes(statusCode);
    const services = (Array.isArray(result) ? result : [])
      .filter((rs: { status: any }) => isSuccess(rs.status))
      .map((rs: { data: any }) => rs.data);

    if (!isSuccess(status) || services.length === 0) {
      throw new Error(result);
    }

    yield put(mobilityContinuationActions.createServiceSuccess(services[0]));
    yield put(push(routes.MOBILITY_CONTINUATION_CONFIRMATION));
  } catch (error) {
    console.log(error);
    yield put(push(routes.DROPOFF));
  } finally {
    yield put(stopLoad({}));
  }
}
